import { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

import { Container } from './styled';

import DYDXIcon from 'src/assets/svg/DYDX.svg';

type ElementProps = {
  value: string;
};

type StyleProps = {
  size?: number;
};

export default function QrCode({ value, size = 300 }: ElementProps & StyleProps) {
  const ref = useRef<HTMLDivElement>(null);

  const { current: qrCode } = useRef(
    new QRCodeStyling({
      type: 'svg',
      width: size,
      height: size,
      data: value,
      backgroundOptions: {
        color: '#252537',
      },
      imageOptions: {
        imageSize: 0.4,
        margin: 12,
      },
      dotsOptions: {
        type: 'dots',
        color: 'white',
      },
      cornersDotOptions: {
        type: 'square',
      },
      image: DYDXIcon,
      cornersSquareOptions: {
        type: 'extra-rounded',
        color: 'white',
      },
      qrOptions: {
        errorCorrectionLevel: 'M',
      },
    }),
  );

  useEffect(() => {
    qrCode.append(ref.current || undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    ref.current?.firstElementChild?.setAttribute('viewBox', `0 0 ${size} ${size}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);

  return <Container ref={ref} />;
}
